import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import GiftCardDeliverySection from 'components/FrictionlessCheckout/GiftCardDeliverySection/GiftCardDeliverySection';
import addressListSelector from 'selectors/order/addressListSelector';
import userUtils from 'utils/User';
import { orderSelector } from 'selectors/order/orderSelector';
import { getAddressList } from 'services/Checkout';
import PreferredZipCodeSelector from 'selectors/user/preferredZipCodeSelector';
const { preferredZipCodeSelector } = PreferredZipCodeSelector;
import ShipAddressActions from 'actions/ShipAddressActions';
import OrderActions from 'actions/OrderActions';
import historyLocationActions from 'actions/framework/HistoryLocationActions';
import GiftCardDeliverySectionEN from 'components/FrictionlessCheckout/GiftCardDeliverySection/locales/GiftCardDeliverySection_en_US';
import GiftCardDeliverySectionFR from 'components/FrictionlessCheckout/GiftCardDeliverySection/locales/GiftCardDeliverySection_fr_CA';
import { SECTION_NAMES } from 'constants/frictionlessCheckout';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(GiftCardDeliverySectionEN, GiftCardDeliverySectionFR);

const loadUserAddressList = () => {
    if (!userUtils.isAnonymous()) {
        const profileId = userUtils.getProfileId();
        const shipCountry = userUtils.getShippingCountry().countryCode;
        getAddressList(profileId, shipCountry);
    }
};

const localization = createStructuredSelector({
    giftCardTitle: getTextFromResource(getText, 'giftCardTitle'),
    free: getTextFromResource(getText, 'free'),
    giftCardSubtitle: getTextFromResource(getText, 'giftCardSubtitle')
});

const cleanAddressList = (addressList = []) => {
    return addressList.filter(address => address.addressType !== 'HAL');
};

const fields = createSelector(
    orderSelector,
    localization,
    addressListSelector,
    preferredZipCodeSelector,
    (_ownState, ownProps) => ownProps.isSdd,
    (order, locale, addressList) => {
        return {
            localization: locale,
            addressList: cleanAddressList(addressList),
            sectionName: SECTION_NAMES.GIFT_CARD_DELIVERY,
            sectionLevelError:
                order.sectionErrors?.[SECTION_NAMES.GIFT_CARD_DELIVERY]?.length && order.sectionErrors?.[SECTION_NAMES.GIFT_CARD_DELIVERY]
        };
    }
);

const functions = {
    goToURL: historyLocationActions.goTo
};

const utilityFunctions = {
    loadUserAddressList,
    getAddressBook: ShipAddressActions.getAddressBook,
    setActiveSection: OrderActions.setCheckoutActiveSection
};

const withGiftCardDeliverySectionProps = wrapHOC(
    connect(fields, functions, (stateProps, dispatchProps, ownProps) => ({
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        ...utilityFunctions
    }))
);

export default withGiftCardDeliverySectionProps(GiftCardDeliverySection);
